import React from "react";

import ManageLearners from "./ManageLearners";

import {
  FranchiseType,
  Learner,
  LearnerAllocationStatus,
  PropositionAllocation,
  UserType,
} from "@hubcapp/types";
import { useAuth } from "@hubcapp/context";
import {
  useQueryGetInstructorPropositionDetails,
  useQueryGetLearners,
} from "@hubcapp/hooks";

const ManageLearnersStateProvider = () => {
  const {
    instructor: { id: instructorId },
  } = useAuth();
  const { data, loading } = useQueryGetLearners({ instructorId });

  const {
    data: instructorDetailsData,
  } = useQueryGetInstructorPropositionDetails(instructorId);

  const franchises = (
    instructorDetailsData?.instructor?.propositions || []
  ).filter(
    (prop: PropositionAllocation) =>
      prop.proposition.type === FranchiseType.Full ||
      prop.proposition.type === FranchiseType.PartnerLite ||
      prop.proposition.type === FranchiseType.Trainee,
  );

  const learners = data?.instructor?.learners || [];

  const pendingLearners = learners.filter(
    ({ allocations, sourcedBy }) =>
      allocations &&
      allocations.length &&
      allocations[0].allocationStatus === LearnerAllocationStatus.Pending &&
      (sourcedBy === UserType.Business || sourcedBy === null),
  );

  const tableLearners: Array<Learner & { approved?: boolean }> = learners
    .filter(
      ({ allocations, sourcedBy }) =>
        allocations &&
        allocations.length &&
        (allocations[0].allocationStatus === LearnerAllocationStatus.Approved ||
          allocations[0].allocationStatus === LearnerAllocationStatus.Pending ||
          sourcedBy === UserType.Instructor),
    )
    .map(learner => ({
      ...learner,
      approved: Boolean(
        learner.allocations &&
          learner.allocations[0] &&
          learner.allocations[0].allocationStatus ===
            LearnerAllocationStatus.Approved,
      ),
    }));

  return (
    <ManageLearners
      pendingLearners={pendingLearners}
      learners={tableLearners}
      loading={loading}
      ableToAddLearners={Boolean(franchises.length)}
    />
  );
};

export default ManageLearnersStateProvider;
